import { JSONContent } from '@tiptap/core';
import { api } from './api';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ArticleTraduccion {
  idioma: string;
  titulo: string;
  resumen: string;
  contenido: object;
}

export interface Article {
  articuloId: number;
  categoriaId: number;
  grupoArticulo: string;
  tiempoDeLectura: number;
  traducciones: ArticleTraduccion[];
   estado: 'PUBLICADO' | 'BORRADOR' |'EN_REVISION' | 'APROBADO';
  urlImagenPortada?: string;
  fechaActualizacion?: string | null;
  usuarioActualizacion?: string | null;
  fechaCreacion?: string | null;
  usuarioCreacion?: string | null;
}

export interface ArticlePayload {
  categoriaId: number;
  grupoArticulo: string;
  tiempoDeLectura: number;
  traducciones: ArticleTraduccion[];
  estado: 'PUBLICADO' | 'BORRADOR' |'EN_REVISION' | 'APROBADO';
  portada?: File; // Opcional: solo se envía si el usuario cargó una nueva imagen
}

// ─── Helper ───────────────────────────────────────────────────────────────────

function toFormData(payload: ArticlePayload): FormData {
  const form = new FormData();
  form.append('categoriaId', String(payload.categoriaId));
  form.append('grupoArticulo', payload.grupoArticulo);
  form.append('tiempoDeLectura', String(payload.tiempoDeLectura));
  form.append('traducciones', JSON.stringify(payload.traducciones));
  form.append('estado', payload.estado);

  // Solo se agrega si hay una imagen nueva (insert siempre, update solo si cambió)
  if (payload.portada) {
    form.append('portada', payload.portada);
  }

  return form;
}

// ─── Service ──────────────────────────────────────────────────────────────────

const ENDPOINT = '/admin/articles';

export const articlesService = {
  getAll: () =>
    api.get<Article[]>(ENDPOINT),

  getById: (id: number) =>
    api.get<Article>(`${ENDPOINT}/${id}`),

  insert: (payload: ArticlePayload) =>
    api.post<Article>(ENDPOINT, toFormData(payload)),

  update: (id: number, payload: ArticlePayload) =>
    api.put<Article>(`${ENDPOINT}/${id}`, toFormData(payload)),

  deleteById: (id: number) =>
    api.delete(`${ENDPOINT}/${id}`),

  translate: (payload: {
    lenguajeDestino: string;
    lenguajeOrigen: string;
    titulo: string;
    categoria: string;
    resumen: string;
    contenido: JSONContent;
  }) =>
    api.post<{
      titulo: string;
      categoria: string;
      resumen: string;
      contenido: JSONContent;
    }>(`${ENDPOINT}/translate`, payload),
};
